import { GET_TERMINATION_NOTE_DETAILS, GET_ADMIN_TERMINATION_NOTE, GET_TERMINATION_NOTES, REMOVE_TERMINATION_NOTE } from "./constants";

export const initialTerminationNote = {
  details: {
    name: "Details",
    subSections: {},
  },
  reason_for_termination: {
    name: "Reason for Termination",
    subSections: {},
  },
  summary_of_treatment: {
    name: "Summary of Treatment",
    subSections: {},
  },
  recommendations: {
    name: "Recommendations",
    subSections: {},
  },
  follow_up_plan: {
    name: "Follow-Up Plan",
    subSections: {},
  },
  closing_statement: {
    name: "Closing Statement",
    subSections: {},
  },
  additional_comments: {
    name: "Additional Comments",
    subSections: {},
  },
};

const terminationInitialState = {
  termination_note: [],
  admin_termination_note: [],
  termination_note_details: JSON.parse(JSON.stringify(initialTerminationNote)),
  isTerminationNote: false,
  isAdminTerminationNotes: false,
};

export const terminationNoteReducer = (state = terminationInitialState, action = { type: "", payload: "" }) => {
  switch (action.type) {
    case GET_TERMINATION_NOTE_DETAILS: {
      return {
        ...state,
        termination_note_details: action.payload,
      };
    }
    case GET_TERMINATION_NOTES: {
      return {
        ...state,
        termination_note: action.payload,
        isTerminationNote: true,
      };
    }
    case GET_ADMIN_TERMINATION_NOTE: {
      return {
        ...state,
        admin_termination_note: action.payload,
        isAdminTerminationNotes: false,
      };
    }
    case REMOVE_TERMINATION_NOTE: {
      const newNote = state.termination_note_details.filter((item) => item.id !== action.payload);
      return {
        ...state,
        termination_note_details: [...newNote],
      };
    }
    default:
      return state;
  }
};
